// Demo / showcase configuration helpers.
// Values come from build-time REACT_APP_* env vars set by the Cloud Run build.

const truthy = (value) => String(value || '').toLowerCase() === 'true';

export const DEMO_CONFIG = {
  enabled: truthy(process.env.REACT_APP_DEMO_MODE),
  username: process.env.REACT_APP_DEMO_USERNAME || 'demo',
  password: process.env.REACT_APP_DEMO_PASSWORD || 'Demo@1234',
  contactUrl: process.env.REACT_APP_CONTACT_URL || 'https://tnewt.com/contact',
  companyName: process.env.REACT_APP_COMPANY_NAME || '',
};

export const isDemoMode = () => DEMO_CONFIG.enabled;
